import { render, staticRenderFns } from "./SumupViewPointScoreRateList.vue?vue&type=template&id=dca7d5d2&"
import script from "./SumupViewPointScoreRateList.vue?vue&type=script&lang=ts&"
export * from "./SumupViewPointScoreRateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports